<template>
  <div class="height-transition-container">
    <div class="add-user-container d-flex flex-column justify-center cursor-text pa-3" @mousedown="focusField">
      <div class="d-flex flex-wrap">
        <div
          v-for="email in emails"
          :key="email"
          class="add-user-preview mr-2 mb-2 flex-shrink-0"
          @mousedown.stop
        >
          {{ email }}
          <v-btn
            variant="plain"
            size="small"
            icon="mds:close"
            @click="() => emit('updateEmails', emails.filter((it) => it !== email))"
            :disabled="disabled"
          />
        </div>
      </div>
      <v-text-field
        :model-value="modelValue"
        @update:modelValue="onUpdate"
        ref="textField"
        variant="solo"
        class="add-user-field"
        placeholder="Add people by email, comma separated"
        single-line
        hide-details
        clear-icon="mds:close"
        clearable
        @blur="addUser"
        @keydown.enter="addUser"
        @mousedown.stop
        :disabled="disabled"
        autocomplete="off"
      />
    </div>
  </div>
</template>

<script setup>
import { useTemplateRef } from 'vue'
import { validateEmail } from '@/utils/validate'

const { modelValue, emails, disabled } = defineProps({ modelValue: String, emails: Array, disabled: Boolean })
const emit = defineEmits(['updateEmails', 'update:modelValue'])

const textField = useTemplateRef('textField')

const onUpdate = (newValue) => {
  emit('update:modelValue', newValue)
}

const addUser = () => {
  const emailsArray = Array.from(new Set((modelValue || '').split(',').map((e) => e.trim())))
  const validEmails = emailsArray.filter((email) => !!validateEmail(email) && !emails.includes(email))
  if (validEmails.length === 0) {
    return
  }

  emit('update:modelValue', '')
  emit('updateEmails', [...emails, ...validEmails])
}

const focusField = (event) => {
  textField.value?.focus()
  if (event) {
    event.stopPropagation()
    event.preventDefault()
  }
}
</script>

<style scoped>
:deep(.add-user-field) {
  min-height: 16px !important;
  max-height: 16px !important;
  height: 16px !important;
  margin-right: -12px;

  .v-field.v-field--variant-solo {
    background-color: transparent !important;
    box-shadow: none !important;
  }

  .v-field__input {
    padding: 0 !important;
    min-height: 16px !important;
    height: 16px !important;
    font-size: 14px !important;
    line-height: 16px !important;
  }
}

.height-transition-container {
  min-height: 84px;
}

.add-user-container {
  min-height: 52px;
  border-radius: 8px;
  border: 1px solid #CFD3D9;
}

.add-user-preview {
  line-height: 20px;
  padding: 6px;
  border-radius: 4px;
  border: 1px solid #CFD3D9;
}
</style>
